import tgpu from 'typegpu';
import * as d from 'typegpu/data';
import * as std from 'typegpu/std';
import {frameLayout} from '../gpu/layouts';
import {vnoise} from './lib';
import {P_INK} from './pigments';
const vary={color:d.vec4f,uv:d.vec2f};
export const trailVertex=tgpu.vertexFn({in:{posSize:d.vec4f,color:d.vec4f,params:d.vec4f},out:{position:d.builtin.position,...vary}})((v)=>{
  'use gpu';
  const f=frameLayout.$.frame;
  const view=f.view.mul(d.vec4f(v.posSize.xyz,1));
  return {position:f.proj.mul(view.add(d.vec4f(0,0,.003,0))),color:v.color,uv:v.params.xy};
});
export const trailFragment=tgpu.fragmentFn({in:vary,out:d.vec4f})((v)=>{
  'use gpu';
  // Opaque pigment dragged by the actual blade, with a dry, broken edge.
  // Values stay below paper white: a slash is painted gold, not a light tube.
  const grain=vnoise(d.vec2f(v.uv.x*31,v.uv.y*53));
  const teeth=vnoise(d.vec2f(v.uv.y*86,3.7));
  const across=std.smoothstep(.015,.2,v.uv.x-teeth*.1);
  const torn=1-std.smoothstep(.88,.99,v.uv.x+(teeth-.5)*.09);
  const edge=std.smoothstep(.68,.88,v.uv.x);
  let color=v.color.xyz.mul(.7+grain*.27);
  color=std.mix(color,color.mul(1.08),edge*.7);
  color=std.mix(color,P_INK.$,(1-std.smoothstep(.13,.24,v.uv.x))*.5);
  const alpha=v.color.w*across*torn*(.72+grain*.28);
  return d.vec4f(color.mul(alpha),alpha);
});
